export var PREMIER_PLUS_FACILITY_CODE = 'PRR';
export var STANDARD_EXTRA_FACILITY_CODE = 'STE';
export var BIGGER_ROOM_CODE = 'bigger-room';
export var NEW_HOTEL_MESSAGING_FLAG_TEXT = 'New hotel';
export var NEW_ROOMS_MESSAGING_FLAG_TEXT = 'New rooms';
export var OPENING_SOON_MESSAGING_FLAG_TEXT = 'Opening soon';
export var PREMIER_EXTRA_CODE = 'premier-extra';
export var MLOS = 'MLOS';